import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	grow: {
		flexGrow: 1,
	},
	title: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	avatarBig: {
		width: theme.spacing(6),
		height: theme.spacing(6),
	},
	iconColor: {
		color: theme.palette.custom.jbAppBar.background,
		fontSize: 30,
	},
	countryDisplay: {
		display: "flex",
		alignItems: "center",
		"& svg": {
			marginRight: "3px",
		},
	},
	select: {
		minHeight: "20px",
		minWidth: 275,
	},
	locationSelectContainer: {
		width: "100%",
		maxWidth: 300,
		backgroundColor: theme.palette.background.paper,
		overflow: "hidden",
	},
}));
